import { AfterViewInit, Component } from "@angular/core";
import * as Sentry from "@sentry/angular";

@Component({
  selector: "app-sentry-feedback",
  standalone: true,
  imports: [],
  template: `<button id="sentry-user-feedback" class="bug-report">Report Bug</button>`,
  styleUrl: "./sentry-feedback.component.scss",
})
export class SentryFeedbackComponent implements AfterViewInit {
  ngAfterViewInit() {
    const feedback = Sentry.getFeedback();
    const userFeedbackButton = document.querySelector("#sentry-user-feedback");
    if (userFeedbackButton) {
      feedback?.attachTo(userFeedbackButton, {
        formTitle: "Report a Bug!",
      });
    }
  }
}
